import axios from "axios";
import { API_URL } from "config/deploymentMode";

const doRequest = async (endpoint, method, data, token, alternativeAPIUrl) => {
    let options = {
        url: `${alternativeAPIUrl || API_URL}${endpoint}`,
        method, 
        data
    };
    if (token)
        options = {
            ...options, 
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
    try {
        const result = await axios(options);
        if (result.request.status === 401) {
            localStorage.clear();
            sessionStorage.clear();
            window.location.reload();
            return [null, new Error("No autorizado")];
        }
        return [result, null];
    }
    catch (err) {
        return [null, err];
    }
}
export const throwError = fetchData => {
    if (fetchData) return;
    throw new Error();
}

export default doRequest;